import encryptFactory from '@igc-lib/encrypter';

const Default_PublicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC3hBYP7XV8YyDU9IHLeu15PFdWM6sQfanoUuPDTkDh0gZPAqc13uk1QHQTuzfELacfcjE4GmVn9bi9IP2C+1Kr0L0EBrq1Awch+oSTGKh9BXoUvw2PvuBwYzcywflGBOLtO0VhdQbRcxr+jtnE/iCSu29ETHZHcqv27W+KSK9UpQIDAQAB';

export function encryptRsa(plainText) {
  const RSAEncryptInstance = encryptFactory('RSA', { publicKey: Default_PublicKey });
  let result = RSAEncryptInstance.encrypt(plainText);
  return result;
}